export default __webpack_public_path__ + "static/media/angle-left-icon.b613ff8c.svg";